<template>
  <div class="headers">
    <div
      class="header-box"
      style="display: flex;justify-content: space-between;align-items: center;height: 100%;"
    >
      <div
        class="header-l rPos fCenter"
        v-s.width="
          window.Math.max(
            window.parseInt(window.$Menus.actived.width) - 33,
            166
          )
        "
        id="MYTab"
        title="点击切换折叠菜单侧边栏"
        v-s.padding-left="window.$Menus.actived.collapse ? '12px' : '10px'"
        style="box-sizing: border-box;"
        @click.stop="
          window.$Menus.toggleCollapse(),
            window.$Events.RightMenuNavCollapsed &&
              $trigger('*RightMenuNavCollapsed')
        "
      >
        <img src="../../static/training.png" width="23px" class="books" />
        <div
          style="display: flex;flex-direction: column; justify-content: space-around;align-items: center;width: 180px;"
        >
          <div>
            <span
              style="flex-shrink: 0;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space:nowrap;"
            >
              <i class="fa fa-leaf" aria-hidden="true"></i>&nbsp;{{
                Title || window.document.title
              }}</span
            >
          </div>
          <div style="font-size: 14px; color: #fcfdfd;" v-if="srName">{{srName}}</div>
        </div>

        <div
          style="height: 100%;position: absolute;right: -20px;top: 1px;z-index: 5;"
          class="fCenter"
        >
          <div
            style="border: 1px dashed var(--Colorfont);width: 0px;height: 47%;"
          ></div>
        </div>
      </div>

      <div id="MYTab">
        <span>
          <pre class="el-icon-s-home" @click="$root.App.Gohomepage()">
  首页</pre
          >
          <i
            v-show="(tmp = window.$Menus.Englishmenus[$route.name])"
            class="el-icon-arrow-right"
            style="margin:0 10px"
            @click="$trigger('*showMenus')"
          ></i>
        </span>

        <span
          v-if="($route, (tmp2 = tmp && tmp.parent) && tmp2.name)"
          @click="$trigger('*showMenus', tmp2.name)"
          class="rPos"
        >
          <span :class="tmp2.icon"> {{ ($route, tmp2.name) }}</span>
          <i class="el-icon-arrow-right" style="margin:0 10px"></i>
          <el-select
            v-model="string2"
            style="position: absolute;width: 75%;top: -20px;opacity: 0;left: 0;"
          >
            <el-option
              v-for="menu in tmp2.submenus"
              :key="menu.name"
              :value="menu.name"
              x:label="menu.name"
              @click.native.stop="$push(menu.path)"
            >
              <span :class="menu.icon || ''"> {{ menu.name }}</span>
            </el-option>
            <!-- <el-option value=1 label='111'></el-option> -->
            <!-- <el-option value=2 label='222'></el-option> -->
          </el-select>
        </span>

        <span @click="window.$refresh()" :class="tmp && tmp.icon">
          {{ ($route, (string2 = tmp ? tmp.name : "")) }}</span
        >
      </div>

      <div
        class="header-y rPos"
        style="position: relative;padding: 0 12px;display: inline-flex;"
      >
        <div
          style="height: 100%;position: absolute;left:55px;top:0;z-index:5"
          class="fCenter"
        >
          <div
            style="border-left: 2px dotted var(--Colorfont);width: 0px;height: 50%;margin-top: 2px;"
          ></div>
        </div>

        <!-- <el-tooltip popper-class="local" effect="light" :content="`未读消息：${number}条，消息总数：${number2}条`" placement="left"> -->
        <el-tooltip
          popper-class="local"
          effect="light"
          :content="`未读消息：${number}条`"
          placement="left"
        >
          <div
            v-view
            class="fCenter rPos"
            style="color: #fcfdfd;"
            @click="$form('__mymsg__')"
            z-hover="opacity:0.8"
          >
            <!-- <img src="../assets/header/message.png" alt="消息" /> 🔔 📥 ➟ ✉ -->
            <span
              style="line-height: normal;font-size:25px;width:25px;margin: 0 35px 0 0;"
              class="el-icon-message-solid"
            ></span>
            <span
              class="chatTotal fCenter"
              v-s:250.opacity="number > 0 ? 1 : 0"
              style="animation:ZOOMsg 0.7s ease-out infinite;z-index: 77;height:13px;"
              s:left='#number > 99 ? "-20px" : "-13px"'
              s:border-radius='#number > 99 ? "9px" : "50%"'
              s:animation='#number > 0 ? "ZOOMsg 0.7s ease-out infinite" : ""'
            >
              {{ number > 99 ? "99+" : number }}
            </span>
          </div>
        </el-tooltip>

        <el-dropdown
          style="width: 100%;"
          aplacement="top-start"
          size="medium"
          :show-timeout="100"
        >
          <span class="el-dropdown-link fCenter">
            <img
              class="nav-user-photo"
              :src="(uphoto = uphoto || '../../../static/images/my.png')"
              id="userPhoto"
              onerror="this.src='../../../static/images/my.png'"
              @click.stop="$trigger('*preview', uphoto, ['我的头像', 35])"
              style="background: #fcfdfd;"
            />
            <span
              class="user-info font14"
              id="user_info"
              @click.stop="
                $form('xupdatePCPassword', { id: A.local('$Userid') })
              "
            >
              {{ userName || "Who Are You"
              }}<!-- <br>群主 -->
            </span>

            <!-- <div @click="chat()" class="chat2 flex rPos" xtitle=" noReadTotal ? '未读消息' + noReadTotal + '条' : '没有未读消息' " z-hover='opacity: 0.8' z-trans style="margin-top: 1px;">
              <el-tooltip class="" effect="light" :content=" noReadTotal ? '未读消息' + noReadTotal + '条' : '没有未读消息' " placement="left">
                <img src="../assets/header/message.png" alt="消息" /> 🔔 📥 ➟ ✉
                <span style="line-height: normal;font-size: 28px;" class="el-icon-message-solid"></span>
              </el-tooltip>
              <div>
                <span class="chatTotal" v-if="noReadTotal>0" style="animation:zoom 0.7s ease-out infinite;">{{noReadTotal}}</span>
              </div>
            </di -->
          </span>
          <el-dropdown-menu
            slot="dropdown"
            style="width:130px;text-align:center;"
          >
            <el-dropdown-item
              @click.native="$push('SelectProject')"
              style="font-size:0.95em;line-height:35px;"
              v-if="A.local('isCustomer') === '1'"
            >
              <i
                class="el-icon-s-promotion xfont15"
                style="color:var(--Themecolor);margin-left:0px;"
              ></i>
              选择项目
            </el-dropdown-item>

            <el-dropdown-item
              :divided="A.local('isCustomer') === '1'"
              @click.native="
                $form('updateUserPassword', { id: A.local('$Userid') })
              "
              style="font-size:0.95em;line-height:35px;"
            >
              <i
                class="el-icon-user-solid xfont15"
                style="color:var(--Themecolor);margin-left:-3px;"
              ></i>
              修改密码
            </el-dropdown-item>
            <el-dropdown-item
              @click.native="$trigger('toggleShowcolor')"
              style="font-size:0.95em;line-height:35px;"
            >
              <i
                class="el-icon-s-open xfont16"
                style="color:var(--Themecolor);margin-left:-3px;"
              ></i>
              修改主题
            </el-dropdown-item>
            <el-dropdown-item
              @click.native="$trigger('*showMenus')"
              style="font-size:0.95em;line-height:35px;"
            >
              <i
                class="el-icon-s-grid xfont16"
                style="color:var(--Themecolor);margin-left:-3px;"
              ></i>
              搜索菜单
            </el-dropdown-item>
            <el-dropdown-item
              @click.native="signOut"
              divided
              style="font-size:0.95em;line-height:35px;"
            >
              <i
                class="el-icon-error xfont15"
                style="color:var(--Themecolor);margin-left:-3px;"
              ></i>
              退出登陆
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <el-color-picker
        ref="color"
        style="opacity: 0;position: absolute;right: 0;top: 7px;z-index: -1;"
        @hook:mounted="window.sleep(5, e => $trigger('parseColor'))"
        v-event.toggleShowcolor="`return C.showPicker = !C.showPicker`"
        v-event.parseColor="
          `
          await window.sleep(5);
          if( S = C.$refs.dropdown ) {
            E = ( S = S.$el.querySelector(&quot;.el-color-dropdown__btns&quot;) ).children[1].firstElementChild;
            E.textContent = &quot;重置&quot;;
            E.addEventListener( &quot;click&quot;, e=>{
                A.Testcolor = true;
                window.$Themecolor = string = window.Vue.Defaultcolor;
                C.showPicker = false;
                e.returnValue = false;
                e.stopPropagation();
                return false;
            }, true );
          };
          C.$watch(&quot;showPicker&quot;,bool=>{
            !bool && string !== window.$Themecolor && ( window.$Themecolor = string );
          });
        `
        "
        @active-change="window.$Themecolor = arguments[0]"
        @change="window.$Themecolor = arguments[0]"
        v-set:string="window.$Themecolor"
        v-model="string"
        show-alpha
        :predefine="predefineColors"
      >
      </el-color-picker>
    </div>

    <myform
      ref="psform"
      :viewobj="{
        updateUserPassword: ['修改用户密码', 'el-icon-edit-outline']
      }"
      :formdata="form"
      :hidebutton="true"
      @close="
        $form('updateUserPassword', 'reset'),
          (form.userPasswordOld = null),
          (form.userPasswordNew = null)
      "
    >
      <div>
        <span>*原密码:</span>
        <el-input
          v-model="form.userPasswordOld"
          type="password"
          style="width: 80%;"
          size="small"
        ></el-input>
      </div>

      <div style="margin: 15px 0;">
        <span>*新密码:</span>
        <el-input
          v-model="form.userPasswordNew"
          type="password"
          style="width: 80%;"
          size="small"
        ></el-input>
      </div>
      <div
        class="dialog-footer"
        style="display: flex;flex-direction: row-reverse;"
      >
        <el-button type="primary" @click="subPassword">确定</el-button>
      </div>

      <hide slot="id" />
    </myform>

    <!-- // [ "#序号|fixed:left?right|align:center", 100 ] v-event.*exitlogin='`_error(true)`' -->
    <!-- view.__mymsg__="消息详情#el-icon-delete#删除所有" -->
    <myform
      width="80%"
      btntype="danger"
      v-set:__msgapi__="
        `/trainingmsg/sys-notice-receive/getSysNoticeReceiveList`
      "
      view.__mymsg__="消息详情"
      v-event.show="
        v =>
          (
            $trigger(
              __msgapi__,
              number > 0 && {
                currentPage: ((
                  $this[
                    '/trainingmsg/sys-notice-receive/getSysNoticeReceiveList_data'
                  ] || {}
                ).currentPage = 1)
              }
            ).trigger || (v => (__once__ = v))
          )(v => clearNumber('clear'))
      "
      @show="$trigger('show')"
      @close="$form('__mymsg__', 'hide'), getMsgUn()"
      @confirm="
        _confirm('确定要删除所有的消息吗?')
          .trigger('/GroupChat/removeNews', __msgdata__, '正在删除所有消息..')
          .trigger('show')
      "
    >
      <mytable
        id="__mymsg__"
        type="html"
        :tableColums="tableColums"
        :api="__msgapi__ + '::id'"
        :data="(__msgdata__ = { newsName: '消息发送------后台通知' })"
        :height="H - 385"
        update="self=>window.sleep(1,v=>number=self.$total$)"
        @update="__once__ && __once__((__once__ = false))"
      >
      </mytable>
    </myform>
  </div>
</template>

<script>
import myhttp from "../utils/myhttp.js";
import api from "../utils/api.js";
import qs from "qs";

const W = window;

export default {
  name: "headers",
  data() {
    // console.warn("username:: ", localStorage.getItem("$Username"));
    return {
      form: {
        userPasswordOld: "",
        userPasswordNew: ""
      },
      srName:localStorage.getItem("$srName"),
      userId: localStorage.getItem("$userId"),
      userName: localStorage.getItem("$Username"),
      uphoto: localStorage.getItem("$uphoto"),
      // isZhubo: localStorage.getItem("$Usertype") == "2",
      predefineColors: [
        "rgba(116, 22, 101, 1)",
        "rgba(74, 9, 63, 1)",
        "rgba(139,0,0,1)",
        "#1F061B",
        "#ff4500",
        // '#ff8c00',
        // '#ffd700',
        // '#90ee90',
        "#00ced1",
        "#1e90ff",
        "#c71585",
        // 'rgba(255, 69, 0, 0.68)',
        "rgb(255, 120, 0)",
        // 'hsv(51, 100, 98)',
        // 'hsva(120, 40, 94, 0.5)',
        "hsl(181, 100%, 37%)"
        // 'hsla(209, 100%, 56%, 0.73)',
        // '#c7158577'
      ],

      tableColums: {
        $selection: false,
        $index: "序号",
        projectName: ["来源", 200],
        noticeTitle: ["标题", 200],
        noticeReportTime: ["时间", 160],
        noticeContent: [
          "消息内容|align:left",
          ""
          // `@text: {{
          //   "<img src='" + ( $row.uphoto||"../../../static/images/my.png" ) + "' class=el-btn-img alt username='" + $row.username + "' onclick=App.$trigger('*preview',this.src,[this.getAttribute('username')+'的头像',35]) >"
          //    + "<span style='" + ( $row.read == 1 ? "color:rgb(233,30,99);animation:zoom 0.3s linear infinite;" : "" ) + "'>" + $row.str1 + "</span>"
          //    + '<span class=el-btn-time >' + $row.noticeReportTime + '</span>'
          //  }} #warn
          //  @click: $row.read == 1 && document.activeElement.children[1].setAttribute('style','')
          // `
        ]
      }
    };
  },

  methods: {
    async subPassword() {
      var s = qs.stringify(this.form);
      const responseData = await myhttp.postFileUsers(
        api.updateUserPassword,
        s
      );
      console.log(responseData);
      if (
        responseData.data.result == "error" ||
        responseData.data.status != 200
      ) {
        this.$notify({
          title: "警告",
          message: responseData.data.msg,
          type: "warning"
        });
        return;
      }
      this.$refs.psform.cancel();
      console.log(this.$refs.psform);
    },
    //  async
    signOut: function() {
      // const resposeData = await myhttp.post("admin/logout", null);
      // A.clearLocal( App.ifExistLogin );
      App.Gorootpage();
      // location.reload();
      // this.$route.meta.$needExited = true;
      // this.$router.push({ path: "/login" });
    },

    async clearNumber(type) {
      // type === 'clear' && await this.$post("/GroupChat/editNewsHaveRead",this.__msgdata__,false);
      // this.$post('/GroupChat/messageNumberOfSystem',null,false)
      // .then(res=>res.isuccess && ( this.number = res.data.systemNewsNumber * 1 || 0 ));
      // if( type !== 'webocket' ) {
      //   const data = this["/trainingmsg/sys-notice-receive/getSysNoticeReceiveList_data"];
      //   // console.error(data && data.total);
      //   this.number2 = data && data.total * 1 || 0;
      // };
    },

    async MyWebSocket(window) {
      // var online = 'ws://192.168.0.104:50000/ws';
      // var online = 'ws://192.168.0.104:50000/ws';
      return;
      var online = "ws://192.168.0.104:50000/ws";
      var wbsocket = (window.wbsocket = this.wbsocket = new WebSocket(online));
      //连接创建后调用
      wbsocket.onopen = function(us) {
        console.warn("链接成功::" + us);
      };

      //关闭连接的时候调用
      wbsocket.onclose = async () => {
        // alert("close");
        console.warn("关闭连接了", this._isDestroyed);
        if (!this._isDestroyed) {
          await sleep(250);
          this.MyWebSocket(window);
        }
      };

      //出错时调用
      wbsocket.onerror = function() {
        // alert("error");
        console.warn("webocket出错了!");
      };

      wbsocket.onmessage = async message => {
        console.log(message.data, this.__msgapi__);
        const api = this.__msgapi__ || "/GroupChat/queryAll";

        this.$trigger(api);

        this.clearNumber("webocket");

        const res = await this.$post(
          api,
          {
            newsName: "消息发送------后台通知",
            currentPage: 1,
            pageSize: 0
          },
          false
        );
        res.isuccess && (this.number2 = res.data.total * 1 || 0);

        // while( !Root ) await sleep(11.3413963345);
      };

      while (wbsocket.readyState != WebSocket.OPEN) {
        await sleep(10);
      }

      // console.error([ this.pageParam.id, Api.user.id ]);
      wbsocket.send("register?true&userId?" + A.local("$Userid"));
      // wbsocket.send("register?true&roomid?" + this.pageParam.id + '&userId?' + A.local('$Userid'));

      return wbsocket;
    },

    async getMsgUn() {
      const data = {
        userId: A.local("$Userid")
      };
      var s = qs.stringify(data);
      const responseData = await myhttp.postFileUsers(
        api.getSysNoticeUnCount,
        s
      );
      this.number = responseData.data.data;
    }
  },
  created() {
    // console.warn(this.uphoto);
    console.warn("header页面初始化!!");
    this.number2 = 0;
    //this.MyWebSocket(W);
    this.getMsgUn();
    this.srName = localStorage.getItem("$srName")||''
  },

  destroyed() {
    // this.wbsocket.close();
    console.error("header页面破坏了!!");
  },
  activated() {
    // console.warn("username:: ", localStorage.getItem("$Username"),99999999999);
  }
};
</script>

<style scoped>
.chatTotal {
  position: absolute;
  top: 13px;
  left: -13px;
  transform: translateY(-50%) translateX(100%);
  background-color: #f56c6c;
  border-radius: 50%;
  color: #fff !important;
  min-width: 13px;
  display: inline-block;
  font-size: 12px;
  /*height: 18px;*/
  /*line-height: 18px;*/
  line-height: normal;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
  -webkit-font-smoothing: antialiased;
}

html,
body {
  padding: 0;
  margin: 0;
}

ul {
  list-style-type: none;
}

#MYTab {
  display: inline-block;
  margin-left: 32px;
  color: var(--Colorfont);
  font-size: 0.97em;
  cursor: pointer;
  opacity: 0.97;
  text-shadow: 0px 0px 0px;
}

#MYTab > *:hover {
  /*color: var(--Colorlight);*/
  transition: all 200ms linear;
  opacity: 0.75;
}

/*.headers {
  height: 47px;
}*/
.header-box {
  margin: 0;
  padding-left: 15px;
  /*padding-right: 15px;*/
  border-width: 0;
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  min-height: 45px;
  background: #438eb9;
  background: var(--Themecolor);
}

.header-l {
  color: var(--Colorfont);
  font-size: 1em !important;
  text-shadow: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: auto;
  margin-left: 0px !important;
}

.header-box .books {
  vertical-align: middle;
  margin-right: 5px;
}

.header-l,
.header-y {
  display: inline-block;
}

.header-y {
  font-size: 12px;
  display: inline-block;
  float: right;
  cursor: pointer;
}

.icon-sanjiaodown {
  font-size: 12px;
}

.header-y .icon-yonghu {
  margin-right: 5px;
}

.astyle {
  color: #606266;
  font-size: 14px;
  text-decoration: none;
}

.ace_nav {
  height: 46px;
}

.ace_nav > li {
  /*line-height: 46px;*/
  height: 46px;
  /*border-left: 1px solid #e1e1e1;*/
  padding: 0;
  position: relative;
  float: left;
}

.ace-icon {
  display: inline-block;
  font-size: 16px;
  color: #fff;
  text-align: center;
  width: 20px;
}

.ace_nav > .grey {
  color: #ffffff;
  text-align: center;
  width: 55px;
}

.badge {
  text-shadow: none;
  font-size: 12px;
  padding-top: 1px;
  padding-bottom: 3px;
  font-weight: normal;
  line-height: 15px;
  background-color: #abbac3;
}

.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  background-color: #777777;
  border-radius: 10px;
}

.bg1 {
  background-color: #555555;
}

.bg2 {
  background-color: #892e65;
}

.bg3 {
  background-color: #2e8965;
}

.bg4 {
  background: #62a8d1;
  background: var(--Themecolor);
  width: 150px;
}

.nav-user-photo {
  margin: 6px 10px;
  margin-left: 0px;
  border-radius: 100%;
  border: 1px solid #fff;
  width: 30px;
  height: 30px;
}

.user-info {
  max-width: 150px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  line-height: 17px;
  top: -1px;
  position: relative;
  /*color: var(--Colorfont);*/
}
</style>

<!-- 修改弹出层 -->
<el-dialog title="个人资料" :visible.sync="dialogFormVisible">
  <el-form :model="form">
      <el-form-item label="用户名" :label-width="$$formLabelWidth">
      <el-input v-model="form.username"  auto-complete="off"></el-input>
      </el-form-item>
       <el-form-item label="编号" :label-width="$$formLabelWidth">
      <el-input v-model="form.number" auto-complete="off"></el-input>
      </el-form-item>
       <el-form-item type="password" label="密码" :label-width="$$formLabelWidth">
      <el-input v-model="form.password1" auto-complete="off"></el-input>
      </el-form-item>
       <el-form-item type="password" label="确认密码" :label-width="$$formLabelWidth">
      <el-input v-model="form.password2" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="姓名" :label-width="$$formLabelWidth">
      <el-input v-model="form.compellation"  auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="手机号" :label-width="$$formLabelWidth">
      <el-input v-model="form.phone"  auto-complete="off"></el-input>
      </el-form-item>
       <el-form-item label="邮箱" :label-width="$$formLabelWidth">
      <el-input type="email" v-model="form.email"  auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="备注" :label-width="$$formLabelWidth">
        <el-input v-model="form.note"  auto-complete="off"></el-input>
      </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
  </div>
</el-dialog>



// WEBPACK FOOTER //
// src/components/$headers.local.vue